import React, { lazy, Suspense, useState, useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Preloader from "../Components/Preloader/Preloader";
import { Header } from "../Components/Header/Header";
import { UserprofileEdit } from "./userprofileEdit";
import { AddProfile } from "./useraddProfile/index";
import { MatchmakerProfileEdit } from "./MatchmakerProfileEdit";
import { Login } from "./Login/Login";
import { Otp } from "./Otp/otp";
import { Signup } from "./Signup/Signup";
import { Forgot } from "./ForgotPassword/Forgot";
import { ForgotPasswordOtp } from "./ForgotPasswordOtp/ForgotPasswordOtp";
import { ResetPassword } from "./ResetPassword/ResetPassword";
import { Transactions } from "./Transactions";
import { ContactUs } from "./ContactUs/ContactUs";
import { Redeem } from "./Home/Redeem";
import { ViewMoreCatalogue } from "./Home/ViewMoreCatalogue";
import { Cart } from "./Cart";
import { SignInOtp } from "./SignInOtp/SignInOtp";

const Home = lazy(() => import("./Home"));

export const Layout = () => {
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  // const token = sessionStorage.getItem("token");
  const tempToken = localStorage.getItem("temp_token");

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const location = useLocation();

  const isAuthPage =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/otp" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/otp-forgot-password" ||
    location.pathname === "/reset-password" ||
    location.pathname === "/signup";
  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <div>
          {/* {!isAuthPage && <Header />} */}
          {token && !isAuthPage && <Header />}
          <main>
            <Suspense fallback={<Preloader />}>
              {/* <Routes>
          
                <Route
                  path="/"
                  element={token ? <Navigate to="/home" /> : <Login />}
                />
                <Route
                  path="/login"
                  element={token ? <Navigate to="/home" /> : <Login />}
                />

                <Route
                  path="/signup"
                  element={token ? <Navigate to="/home" /> : <Signup />}
                />

                <Route
                  path="/otp"
                  element={token ? <Navigate to="/home" /> : <Otp />}
                />

                <Route
                  path="/forgot-password"
                  element={token ? <Navigate to="/home" /> : <Forgot />}
                />

                <Route
                  path="/otp-forgot-password"
                  element={
                    token ? <Navigate to="/home" /> : <ForgotPasswordOtp />
                  }
                />

                <Route path="/reset-password" element={<ResetPassword />} />

                {token ? (
                  <>
                    <Route path="/home" element={<Home />} />
                    <Route path="/trasactions" element={<Transactions />} />
                    <Route
                      path="/edit-profile/:id"
                      element={<UserprofileEdit />}
                    />
                    <Route path="/add-profile" element={<AddProfile />} />
                    <Route
                      path="/profile-edit"
                      element={<MatchmakerProfileEdit />}
                    />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/redeem" element={<Redeem />} />
                    <Route path="/view-more-catalogue" element={<ViewMoreCatalogue/>}/>
                  </>
                ) : (
                  <Route path="*" element={<Navigate to="/login" />} />
                )}

            
                <Route path="*" element={<Navigate to="/" />} />
              </Routes> */}
              <Routes>
                {!token ? (
                  <>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signin-otp" element={<SignInOtp/>}/>

                    <Route path="/signup" element={<Signup />} />

                    <Route path="/otp" element={<Otp />} />

                    <Route path="/forgot-password" element={<Forgot />} />

                    <Route
                      path="/otp-forgot-password"
                      element={<ForgotPasswordOtp />}
                    />

                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="*" element={<Login />} />
                  </>
                ) : (
                  <>
                    <Route path="/" element={<Navigate to="/home" replace />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/trasactions" element={<Transactions />} />
                    <Route
                      path="/edit-profile/:id"
                      element={<UserprofileEdit />}
                    />
                    <Route path="/add-profile" element={<AddProfile />} />
                    <Route
                      path="/profile-edit"
                      element={<MatchmakerProfileEdit />}
                    />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/redeem" element={<Redeem />} />
                    <Route
                      path="/view-more-catalogue"
                      element={<ViewMoreCatalogue />}
                    />
                    {/* on forgot password otp screen verify-otp api sending token so /reset-password should on token also */}
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/cart" element={<Cart/>}/>
                    <Route path="*" element={<Home />} />
                  </>
                )}
              </Routes>
            </Suspense>
          </main>
        </div>
      )}
    </>
  );
};
